import { render, staticRenderFns } from "./card-item.vue?vue&type=template&id=5682006c&scoped=true"
import script from "./card-item.vue?vue&type=script&lang=js"
export * from "./card-item.vue?vue&type=script&lang=js"
import style0 from "./card-item.vue?vue&type=style&index=0&id=5682006c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682006c",
  null
  
)

export default component.exports